import './index.css'
import * as React from 'react'
type Props = {
  value: string | number
  valueSuffix?: string
  percentage: number
  color?: string
}

/**
 * Circular progress indicator component with customizable value display
 * Shows a percentage-based circular progress bar with a central value
 * @param value - The main value to display in the center
 * @param valueSuffix - Optional suffix to append to the value
 * @param percentage - Percentage for the circular progress (0-100)
 * @param color - Optional color for the progress stroke
 */
const CircleIndicator = ({
  value,
  percentage,
  color,
  valueSuffix,
}: Props): React.ReactElement<'div'> => (
  <div className="circle-indicator">
    <div className="circle-indicator__value">
      <span className="circle-indicator__value__string">
        {value}
        {valueSuffix}
      </span>
    </div>
    <div className="circle-indicator__container">
      <svg className="circular-chart" viewBox="0 0 36 36">
        <path
          className="circle-bg"
          d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="circle"
          stroke={color}
          strokeDasharray={`${percentage} 100`}
          d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      </svg>
    </div>
  </div>
)

export default CircleIndicator
